export class PoiHistory {
  public uid: number;
  public uid_poi: number;
  public average: number;
  public distance_traveled: number;
  public distance_target: number;
  public engine: number;
  public longitude: number;
  public latitude: number;
  public next_start: number;
  public registration: string;
  public start: number;
  public stop: number;
  public timeVisited: number;
  public uid_device: number;
  public lastStart: number;
  public lastStop: number;

  public get duration() {
    return this.stop - this.start;
  }
  public get stopDuration() {
    return this.next_start - this.stop;
  }

  public constructor(poiCategoryBack?) {
    this.uid = poiCategoryBack?.uid || null;
    this.uid_poi = poiCategoryBack?.uid_poi || null;
    this.average = poiCategoryBack?.average || null;
    this.distance_traveled = poiCategoryBack?.distance_traveled || null;
    this.distance_target = poiCategoryBack?.distance_target || null;
    this.engine = poiCategoryBack?.engine || null;
    this.longitude = poiCategoryBack?.longitude || null;
    this.next_start = poiCategoryBack?.next_start || null;
    this.registration = poiCategoryBack?.registration || null;
    this.start = poiCategoryBack?.start || null;
    this.stop = poiCategoryBack?.stop || null;
    this.timeVisited = poiCategoryBack?.timeVisited || null;
    this.uid_device = poiCategoryBack?.uid_device || null;
    this.lastStart = poiCategoryBack?.lastStart || null;
    this.lastStop = poiCategoryBack?.lastStop || null;
  }
}

export class PoiHistoryStats {
  public timeVisited: number;
  public engine: number;
  public timeSpent: number;
  public maxStop: number;
  public minStop: number;
  public lastStart: number;
  public lastStop: number;
  public isThere: boolean;
  public averageTimeSpent: number;
  public average: number;
  public averageEngine: number;
  public totalEngineAverages: number;
  public deviceUid: number;

  public constructor(poiStatsBack?) {
    this.timeSpent = poiStatsBack?.timeSpent || 0;
    this.maxStop = poiStatsBack?.maxStop || 0;
    this.average = poiStatsBack?.average || 0;
    this.minStop = poiStatsBack?.minStop || 0;
    this.isThere = poiStatsBack?.isThere || undefined;
    this.engine = poiStatsBack?.engine || 0;
    this.averageTimeSpent = poiStatsBack?.averageTimeSpent || 0;
    this.averageEngine = poiStatsBack?.averageEngine || 0;
    this.totalEngineAverages = poiStatsBack?.totalEngineAverages || 0;
    this.timeVisited = poiStatsBack?.timeVisited || 0;
    this.lastStart = poiStatsBack?.lastStart || 0;
    this.lastStop = poiStatsBack?.lastStop || 0;
  }
}
